import React, { useState, useRef, useEffect } from 'react';
import LoadingScreen from './components/LoadingScreen';
import LandingPage from './components/LandingPage';
import bgVideo from './assets/bg.mp4';
import bgVideoMobile from './assets/bg_mobile.mp4';
import './App.css';

function App() {
  const [userClickedEnter, setUserClickedEnter] = useState(false);
  const [videoIsReady, setVideoIsReady] = useState(false);

  const desktopVideoRef = useRef(null);
  const mobileVideoRef = useRef(null);

  // We'll hide the loading overlay only if both are true
  const showLoading = !(userClickedEnter && videoIsReady);

  // Called when the user clicks "Enter" on the loading screen
  const handleLoadingComplete = () => {
    setUserClickedEnter(true);
  };

  // Optional: set video playbackRate once mounted
  useEffect(() => {
    if (desktopVideoRef.current) {
      desktopVideoRef.current.playbackRate = 0.7;
    }
    if (mobileVideoRef.current) {
      mobileVideoRef.current.playbackRate = 0.8;
    }
  }, []);

  // Listen for when the video can play through (desktop or mobile).
  // If EITHER triggers, mark videoIsReady=true (or do more advanced logic if you want both).
  useEffect(() => {
    const desktopVideo = desktopVideoRef.current;
    const mobileVideo = mobileVideoRef.current;

    function handleCanPlayThrough() {
      setVideoIsReady(true);
    }

    if (desktopVideo) {
      desktopVideo.addEventListener('canplaythrough', handleCanPlayThrough, {
        once: true,
      });
    }
    if (mobileVideo) {
      mobileVideo.addEventListener('canplaythrough', handleCanPlayThrough, {
        once: true,
      });
    }

    return () => {
      if (desktopVideo) {
        desktopVideo.removeEventListener('canplaythrough', handleCanPlayThrough);
      }
      if (mobileVideo) {
        mobileVideo.removeEventListener('canplaythrough', handleCanPlayThrough);
      }
    };
  }, []);

  return (
    <div id="app" className="relative text-white font-orbitron min-h-screen">
      {/* VIDEO CONTAINER (always in DOM for immediate loading) */}
      <div className="video-container absolute inset-0 z-0">
        {/* Desktop video */}
        <video
          ref={desktopVideoRef}
          className="video-bg desktop-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src={bgVideo} type="video/mp4" />
        </video>

        {/* Mobile video */}
        <video
          ref={mobileVideoRef}
          className="video-bg mobile-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src={bgVideoMobile} type="video/mp4" />
        </video>
      </div>

      {/* BLACK OVERLAY + LOADING SCREEN */}
      {showLoading && (
        <div
          className="
            absolute 
            inset-0 
            z-50 
            flex 
            items-center 
            justify-center 
            bg-black 
          "
        >
          <LoadingScreen onLoadingComplete={handleLoadingComplete} />
        </div>
      )}

      {/* LANDING PAGE (only visible when not loading) */}
      {!showLoading && (
        <div className="relative z-10">
          <LandingPage />
        </div>
      )}
    </div>
  );
}

export default App;
